/**
 * When a conversation was last touched, as a person would say it.
 *
 * Relative rather than a timestamp: the question a session card answers is "is this
 * the one I was just in", and "2 hours ago" answers it where a date does not.
 *
 * Shared rather than copied. Two session lists now exist, one per model and one for
 * the models list, and they are drawn to look like the same thing. A second copy of
 * this drifts in wording the moment either is edited, and "3h ago" beside "3 hours
 * ago" on two identical-looking cards reads as two different kinds of time.
 */
export function whenReadable(iso: string, now: number = Date.now()): string {
  const then = Date.parse(iso);
  if (Number.isNaN(then)) return '';
  const mins = Math.round((now - then) / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins} min ago`;
  const hours = Math.round(mins / 60);
  if (hours < 24) return `${hours} ${hours === 1 ? 'hour' : 'hours'} ago`;
  const days = Math.round(hours / 24);
  if (days < 7) return `${days} ${days === 1 ? 'day' : 'days'} ago`;
  return new Date(then).toLocaleDateString();
}
